<template>
    <div style="clear:both;">
        <div class="" v-for="(option, index) in formElement.dynamicTypeData.options" v-bind:key="index" style="margin-bottom:10px;">
            <div class="ui checkbox ">
                <input 
                    type="checkbox" 
                    class="cbx" 
                    style="display: none;"
                    :value="index"
                    v-model="formElement.dynamicTypeData.selectedIndexList"
                    :id="formElement.formElementId + index" 
                >
                <label class="check" :for="formElement.formElementId + index">
                    <svg width="18px" height="18px" viewBox="0 0 18 18">
                        <path
                            d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z">
                        </path>
                        <polyline points="1 9 7 14 15 4"></polyline>
                    </svg>
                    <span>{{option}}</span>
                </label>
            </div>
        </div>
         <p class="error" v-if="formElement.dynamicTypeData.isValid !== undefined && !formElement.dynamicTypeData.isValid" v-html="formElement.dynamicTypeData.errorText" />
    </div>
</template>


<script>
export default {
  name: "kollecto-checkbox",
  props: ["formElement", "userAction"],
  created() {
    if (this.userAction === "create" || !this.userAction) {
      if (
        this.formElement.dynamicTypeData.defaultSelectedIndexList &&
        this.formElement.dynamicTypeData.defaultSelectedIndexList > 0
      ) {
        // eslint-disable-next-line
        this.formElement.dynamicTypeData.selectedIndexList = this.formElement.dynamicTypeData.options.filter((opt, index) => {
            return (
              this.formElement.dynamicTypeData.defaultSelectedIndexList.indexOf(
                index
              ) > -1
            );
          }
        );
      }
    }
  }
};
</script>
